exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header h2[data-v-fa8bff12]{margin:.5em 1em .5em 1em}.card-body>ul[data-v-fa8bff12]{margin:0;padding:1em}.card-body>div[data-v-fa8bff12]{padding:0 1em 0 1em}.card-body>div h2[data-v-fa8bff12]{font-size:1.2em;font-weight:700}li[data-v-fa8bff12],pre[data-v-fa8bff12]{width:100%;overflow:auto;padding-top:10px;word-break:break-word}.initial[data-v-fa8bff12]{text-align:center}.initial h2[data-v-fa8bff12]{font-size:20px;margin:.3em}.initial img[data-v-fa8bff12]{max-width:70%;max-height:216px;margin:auto}", ""]);

// exports
